import { createApp } from 'vue'
import { createPinia } from 'pinia'
import {
   createRouter,
   createWebHistory,
} from 'vue-router'

import App from '@clevver/app.vue'

import Glyph from '@clevver/helpers/glyph.vue'
import Card from '@clevver/components/card/card.vue'
import CardBody from '@clevver/components/card/card-body.vue'
import CardFooter from '@clevver/components/card/card-footer.vue'
import CardHeader from '@clevver/components/card/card-header.vue'
import ProgressBar from '@clevver/components/progress-bar.vue'

import MenuItem from '@clevver/components/sidebar/menu-item.vue'

import CopyToClipboard from '@clevver/components/copy-to-clipboard.vue'

import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

import * as bootstrap from 'bootstrap'

import { routes } from '@clevver/routes'

const Pinia = createPinia()
const app = createApp(App)

app.component('Glyph', Glyph)
app.component('Card', Card)
app.component('CardBody', CardBody)
app.component('CardFooter', CardFooter)
app.component('CardHeader', CardHeader)
app.component('ProgressBar', ProgressBar)
app.component('MenuItem', MenuItem)
app.component('copy-to-clipboard', CopyToClipboard)

window["bootstrap"] = bootstrap

const router = createRouter({
   history: createWebHistory(),
   routes,
})

let selector = '#clevver'
let el = document.querySelector(selector) as HTMLElement

if (el) {
   app.config.globalProperties.$pricePerMb = el.dataset.displayPrice
   app.config.globalProperties.$stripeKey = el.dataset.stripePk
}

app.use(Pinia)
   .use(router)
   .use(Toast)
   .mount('#clevver')